import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "comment" }
const _hoisted_2 = { class: "commentBody" }
const _hoisted_3 = { class: "commentAuthor" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comment_text = _resolveComponent("comment-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.comment.author.name), 1),
      _createVNode(_component_comment_text, { comment: _ctx.comment }, null, 8, ["comment"]),
      (_ctx.comment.attachments.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comment.attachments, (x, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "fs-12"
            }, [
              _createElementVNode("a", {
                class: "text-orange",
                href: x.publicUrl,
                target: "_blank"
              }, _toDisplayString(x.filename), 9, _hoisted_4)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.canRemove)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "commentRemover",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeComment && _ctx.removeComment(...args)), ["stop"]))
          }, " x "))
        : _createCommentVNode("", true)
    ])
  ]))
}